export class CustomerSubscriptionRequestModel {
  SubscriptionId: number = 0;
  CustomerId: number = 0;
  StartDate: Date | string;
  EndDate: Date | string;
  Status: string = '';
  SubscriptionVolume: string = '';
  SubscriptionType: string = '';
  SubscriptionContactName: string = '';
  SubscriptionContactEmail: string = '';
  CreatedBy: number = 0;
  ModifiedBy: number = 0;
}

export class GetCustomerSubscriptionsRequestModel {
  CustomerId?: number;
  Status?: string;
  SearchText?: string;
  PageNumber: number = 1;
  PageSize: number = 10;
  SortColumn?: string;
  SortDirection?: string;
  CustomerName?: string;
}
